import {getFunctions,httpsCallable} from 'firebase/functions';
const call=async(name,data)=>(await httpsCallable(getFunctions(),name)(data)).data;
export const consultarActividad=data=>call('consultarActividad',data);
export const recuperarActividad=data=>call('recuperarActividad',data);
export const gestionarComisiones=data=>call('gestionarComisiones',data);

export const consultarComisiones=data=>call('consultarComisiones',data);

export const consultarMetas=data=>call('consultarMetas',data);
